const shopifyCart = class {
  cart;
  constructor() {
    this.init();
  }
  init = async () => {
    this.cart = await this.getCart();
  };
  clearCart = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await fetch("/cart/clear.js/?sections[]=cart-icon-bubble&sections[]=cart-drawer&sections[]=cart-notification-product", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  getCart = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await fetch("/cart.json", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  appendCartSections = () => {
    return {
      'sections': 'cart-drawer,cart-icon-bubble',
      'sections_url': window.location.pathname
    };
  };
  addItem = async (variantId, quantity, properties = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            quantity: quantity,
            id: variantId,
            properties: properties
          })
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  addItems = async (itemsArray, showCart = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const extras = showCart == true ? this.appendCartSections() : '';
        const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: itemsArray,
            ...extras
          })
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  removeItem = async data => {
    return new Promise(async (resolve, reject) => {
      console.log(data);
      try {
        const result = await fetch("/cart/change.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            data,
            quantity: 0
          })
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  removeItemById = async lineItemId => {
    return this.removeItem({
      id: lineItemId
    });
  };
  removeItemByLineNumber = async lineNumber => {
    return this.removeItem({
      line: lineNumber
    });
  };
  updateItem = async data => {
    return new Promise(async (resolve, reject) => {
      console.log(data);
      try {
        const result = await fetch("/cart/change.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        });
        return resolve(result.json());
      } catch (error) {
        reject(error);
      }
    });
  };
  updateItemById = async (lineItemId, newQuantity, newProperties = {}) => {
    return this.updateItem({
      quantity: newQuantity,
      id: lineItemId,
      properties: newProperties
    });
  };
  updateItemByLineNumber = async (lineNumber, newQuantity, newProperties = {}) => {
    return this.updateItem({
      quantity: newQuantity,
      line: lineNumber,
      properties: newProperties
    });
  };
};

/**
 * Returns the user's browsing context suggestions.
 */
const getBrowsingContext = async () => await fetch(window.Shopify.routes.root + "browsing_context_suggestions.json" + "?country[enabled]=true" + `&country[exclude]=${window.Shopify.country}` + "&language[enabled]=true" + `&language[exclude]=${window.Shopify.language}`).then(data => data.json());

// nb. This is for IE10 and lower _only_.
var supportCustomEvent = window.CustomEvent;
if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
  supportCustomEvent = function CustomEvent(event, x) {
    x = x || {};
    var ev = document.createEvent('CustomEvent');
    ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
    return ev;
  };
  supportCustomEvent.prototype = window.Event.prototype;
}

/**
 * Dispatches the passed event to both an "on<type>" handler as well as via the
 * normal dispatch operation. Does not bubble.
 *
 * @param {!EventTarget} target
 * @param {!Event} event
 * @return {boolean}
 */
function safeDispatchEvent(target, event) {
  var check = 'on' + event.type.toLowerCase();
  if (typeof target[check] === 'function') {
    target[check](event);
  }
  return target.dispatchEvent(event);
}

/**
 * @param {Element} el to check for stacking context
 * @return {boolean} whether this el or its parents creates a stacking context
 */
function createsStackingContext(el) {
  while (el && el !== document.body) {
    var s = window.getComputedStyle(el);
    var invalid = function(k, ok) {
      return !(s[k] === undefined || s[k] === ok);
    };

    if (s.opacity < 1 ||
        invalid('zIndex', 'auto') ||
        invalid('transform', 'none') ||
        invalid('mixBlendMode', 'normal') ||
        invalid('filter', 'none') ||
        invalid('perspective', 'none') ||
        s['isolation'] === 'isolate' ||
        s.position === 'fixed' ||
        s.webkitOverflowScrolling === 'touch') {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}

/**
 * Finds the nearest <dialog> from the passed element.
 *
 * @param {Element} el to search from
 * @return {HTMLDialogElement} dialog found
 */
function findNearestDialog(el) {
  while (el) {
    if (el.localName === 'dialog') {
      return /** @type {HTMLDialogElement} */ (el);
    }
    if (el.parentElement) {
      el = el.parentElement;
    } else if (el.parentNode) {
      el = el.parentNode.host;
    } else {
      el = null;
    }
  }
  return null;
}

/**
 * Blur the specified element, as long as it's not the HTML body element.
 * This works around an IE9/10 bug - blurring the body causes Windows to
 * blur the whole application.
 *
 * @param {Element} el to blur
 */
function safeBlur(el) {
  // Find the actual focused element when the active element is inside a shadow root
  while (el && el.shadowRoot && el.shadowRoot.activeElement) {
    el = el.shadowRoot.activeElement;
  }

  if (el && el.blur && el !== document.body) {
    el.blur();
  }
}

/**
 * @param {!NodeList} nodeList to search
 * @param {Node} node to find
 * @return {boolean} whether node is inside nodeList
 */
function inNodeList(nodeList, node) {
  for (var i = 0; i < nodeList.length; ++i) {
    if (nodeList[i] === node) {
      return true;
    }
  }
  return false;
}

/**
 * @param {HTMLFormElement} el to check
 * @return {boolean} whether this form has method="dialog"
 */
function isFormMethodDialog(el) {
  if (!el || !el.hasAttribute('method')) {
    return false;
  }
  return el.getAttribute('method').toLowerCase() === 'dialog';
}

/**
 * @param {!DocumentFragment|!Element} hostElement
 * @return {?Element}
 */
function findFocusableElementWithin(hostElement) {
  // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
  // alternative involves stepping through and trying to focus everything.
  var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
  var query = opts.map(function(el) {
    return el + ':not([disabled])';
  });
  // TODO(samthor): tabindex values that are not numeric are not focusable.
  query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
  var target = hostElement.querySelector(query.join(', '));

  if (!target && 'attachShadow' in Element.prototype) {
    // If we haven't found a focusable target, see if the host element contains an element
    // which has a shadowRoot.
    // Recursively search for the first focusable item in shadow roots.
    var elems = hostElement.querySelectorAll('*');
    for (var i = 0; i < elems.length; i++) {
      if (elems[i].tagName && elems[i].shadowRoot) {
        target = findFocusableElementWithin(elems[i].shadowRoot);
        if (target) {
          break;
        }
      }
    }
  }
  return target;
}

/**
 * Determines if an element is attached to the DOM.
 * @param {Element} element to check
 * @return {boolean} whether the element is in DOM
 */
function isConnected(element) {
  return element.isConnected || document.body.contains(element);
}

/**
 * @param {!Event} event
 * @return {?Element}
 */
function findFormSubmitter(event) {
  if (event.submitter) {
    return event.submitter;
  }

  var form = event.target;
  if (!(form instanceof HTMLFormElement)) {
    return null;
  }

  var submitter = dialogPolyfill.formSubmitter;
  if (!submitter) {
    var target = event.target;
    var root = ('getRootNode' in target && target.getRootNode() || document);
    submitter = root.activeElement;
  }

  if (!submitter || submitter.form !== form) {
    return null;
  }
  return submitter;
}

/**
 * @param {!Event} event
 */
function maybeHandleSubmit(event) {
  if (event.defaultPrevented) {
    return;
  }
  var form = /** @type {!HTMLFormElement} */ (event.target);

  // We'd have a value if we clicked on an imagemap.
  var value = dialogPolyfill.imagemapUseValue;
  var submitter = findFormSubmitter(event);
  if (value === null && submitter) {
    value = submitter.value;
  }

  // There should always be a dialog as this handler is added specifically on them, but check just
  // in case.
  var dialog = findNearestDialog(form);
  if (!dialog) {
    return;
  }

  // Prefer formmethod on the button.
  var formmethod = submitter && submitter.getAttribute('formmethod') || form.getAttribute('method');
  if (formmethod !== 'dialog') {
    return;
  }
  event.preventDefault();

  if (value != null) {
    // nb. we explicitly check against null/undefined
    dialog.close(value);
  } else {
    dialog.close();
  }
}

/**
 * @param {!HTMLDialogElement} dialog to upgrade
 * @constructor
 */
function dialogPolyfillInfo(dialog) {
  this.dialog_ = dialog;
  this.replacedStyleTop_ = false;
  this.openAsModal_ = false;

  // Set a11y role. Browsers that support dialog implicitly know this already.
  if (!dialog.hasAttribute('role')) {
    dialog.setAttribute('role', 'dialog');
  }

  dialog.show = this.show.bind(this);
  dialog.showModal = this.showModal.bind(this);
  dialog.close = this.close.bind(this);

  dialog.addEventListener('submit', maybeHandleSubmit, false);

  if (!('returnValue' in dialog)) {
    dialog.returnValue = '';
  }

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(this.maybeHideModal.bind(this));
    mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
  } else {
    // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
    // seem to fire even if the element was removed as part of a parent removal. Use the removed
    // events to force downgrade (useful if removed/immediately added).
    var removed = false;
    var cb = function() {
      removed ? this.downgradeModal() : this.maybeHideModal();
      removed = false;
    }.bind(this);
    var timeout;
    var delayModel = function(ev) {
      if (ev.target !== dialog) { return; }  // not for a child element
      var cand = 'DOMNodeRemoved';
      removed |= (ev.type.substr(0, cand.length) === cand);
      window.clearTimeout(timeout);
      timeout = window.setTimeout(cb, 0);
    };
    ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
      dialog.addEventListener(name, delayModel);
    });
  }
  // Note that the DOM is observed inside DialogManager while any dialog
  // is being displayed as a modal, to catch modal removal from the DOM.

  Object.defineProperty(dialog, 'open', {
    set: this.setOpen.bind(this),
    get: dialog.hasAttribute.bind(dialog, 'open')
  });

  this.backdrop_ = document.createElement('div');
  this.backdrop_.className = 'backdrop';
  this.backdrop_.addEventListener('mouseup'  , this.backdropMouseEvent_.bind(this));
  this.backdrop_.addEventListener('mousedown', this.backdropMouseEvent_.bind(this));
  this.backdrop_.addEventListener('click'    , this.backdropMouseEvent_.bind(this));
}

dialogPolyfillInfo.prototype = /** @type {HTMLDialogElement.prototype} */ ({

  get dialog() {
    return this.dialog_;
  },

  /**
   * Maybe remove this dialog from the modal top layer. This is called when
   * a modal dialog may no longer be tenable, e.g., when the dialog is no
   * longer open or is no longer part of the DOM.
   */
  maybeHideModal: function() {
    if (this.dialog_.hasAttribute('open') && isConnected(this.dialog_)) { return; }
    this.downgradeModal();
  },

  /**
   * Remove this dialog from the modal top layer, leaving it as a non-modal.
   */
  downgradeModal: function() {
    if (!this.openAsModal_) { return; }
    this.openAsModal_ = false;
    this.dialog_.style.zIndex = '';

    // This won't match the native <dialog> exactly because if the user set top on a centered
    // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
    // possible to polyfill this perfectly.
    if (this.replacedStyleTop_) {
      this.dialog_.style.top = '';
      this.replacedStyleTop_ = false;
    }

    // Clear the backdrop and remove from the manager.
    this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
    dialogPolyfill.dm.removeDialog(this);
  },

  /**
   * @param {boolean} value whether to open or close this dialog
   */
  setOpen: function(value) {
    if (value) {
      this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
    } else {
      this.dialog_.removeAttribute('open');
      this.maybeHideModal();  // nb. redundant with MutationObserver
    }
  },

  /**
   * Handles mouse events ('mouseup', 'mousedown', 'click') on the fake .backdrop element, redirecting them as if
   * they were on the dialog itself.
   *
   * @param {!Event} e to redirect
   */
  backdropMouseEvent_: function(e) {
    if (!this.dialog_.hasAttribute('tabindex')) {
      // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
      // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
      // would not be needed - clicks would move the implicit cursor there.
      var fake = document.createElement('div');
      this.dialog_.insertBefore(fake, this.dialog_.firstChild);
      fake.tabIndex = -1;
      fake.focus();
      this.dialog_.removeChild(fake);
    } else {
      this.dialog_.focus();
    }

    var redirectedEvent = document.createEvent('MouseEvents');
    redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
        e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
        e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
    this.dialog_.dispatchEvent(redirectedEvent);
    e.stopPropagation();
  },

  /**
   * Focuses on the first focusable element within the dialog. This will always blur the current
   * focus, even if nothing within the dialog is found.
   */
  focus_: function() {
    // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
    var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
    if (!target && this.dialog_.tabIndex >= 0) {
      target = this.dialog_;
    }
    if (!target) {
      target = findFocusableElementWithin(this.dialog_);
    }
    safeBlur(document.activeElement);
    target && target.focus();
  },

  /**
   * Sets the zIndex for the backdrop and dialog.
   *
   * @param {number} dialogZ
   * @param {number} backdropZ
   */
  updateZIndex: function(dialogZ, backdropZ) {
    if (dialogZ < backdropZ) {
      throw new Error('dialogZ should never be < backdropZ');
    }
    this.dialog_.style.zIndex = dialogZ;
    this.backdrop_.style.zIndex = backdropZ;
  },

  /**
   * Shows the dialog. If the dialog is already open, this does nothing.
   */
  show: function() {
    if (!this.dialog_.open) {
      this.setOpen(true);
      this.focus_();
    }
  },

  /**
   * Show this dialog modally.
   */
  showModal: function() {
    if (this.dialog_.hasAttribute('open')) {
      throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
    }
    if (!isConnected(this.dialog_)) {
      throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
    }
    if (!dialogPolyfill.dm.pushDialog(this)) {
      throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
    }

    if (createsStackingContext(this.dialog_.parentElement)) {
      console.warn('A dialog is being shown inside a stacking context. ' +
          'This may cause it to be unusable. For more information, see this link: ' +
          'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
    }

    this.setOpen(true);
    this.openAsModal_ = true;

    // Optionally center vertically, relative to the current viewport.
    if (dialogPolyfill.needsCentering(this.dialog_)) {
      dialogPolyfill.reposition(this.dialog_);
      this.replacedStyleTop_ = true;
    } else {
      this.replacedStyleTop_ = false;
    }

    // Insert backdrop.
    this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);

    // Focus on whatever inside the dialog.
    this.focus_();
  },

  /**
   * Closes this HTMLDialogElement. This is optional vs clearing the open
   * attribute, however this fires a 'close' event.
   *
   * @param {string=} opt_returnValue to use as the returnValue
   */
  close: function(opt_returnValue) {
    if (!this.dialog_.hasAttribute('open')) {
      throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
    }
    this.setOpen(false);

    // Leave returnValue untouched in case it was set directly on the element
    if (opt_returnValue !== undefined) {
      this.dialog_.returnValue = opt_returnValue;
    }

    // Triggering "close" event for any attached listeners on the <dialog>.
    var closeEvent = new supportCustomEvent('close', {
      bubbles: false,
      cancelable: false
    });
    safeDispatchEvent(this.dialog_, closeEvent);
  }

});

var dialogPolyfill = {};

dialogPolyfill.reposition = function(element) {
  var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
  element.style.top = Math.max(scrollTop, topValue) + 'px';
};

dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
  for (var i = 0; i < document.styleSheets.length; ++i) {
    var styleSheet = document.styleSheets[i];
    var cssRules = null;
    // Some browsers throw on cssRules.
    try {
      cssRules = styleSheet.cssRules;
    } catch (e) {}
    if (!cssRules) { continue; }
    for (var j = 0; j < cssRules.length; ++j) {
      var rule = cssRules[j];
      var selectedNodes = null;
      // Ignore errors on invalid selector texts.
      try {
        selectedNodes = document.querySelectorAll(rule.selectorText);
      } catch(e) {}
      if (!selectedNodes || !inNodeList(selectedNodes, element)) {
        continue;
      }
      var cssTop = rule.style.getPropertyValue('top');
      var cssBottom = rule.style.getPropertyValue('bottom');
      if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
        return true;
      }
    }
  }
  return false;
};

dialogPolyfill.needsCentering = function(dialog) {
  var computedStyle = window.getComputedStyle(dialog);
  if (computedStyle.position !== 'absolute') {
    return false;
  }

  // We must determine whether the top/bottom specified value is non-auto.  In
  // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
  // Firefox returns the used value. So we do this crazy thing instead: check
  // the inline style and then go through CSS rules.
  if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
      (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
    return false;
  }
  return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
};

/**
 * @param {!Element} element to force upgrade
 */
dialogPolyfill.forceRegisterDialog = function(element) {
  if (window.HTMLDialogElement || element.showModal) {
    console.warn('This browser already supports <dialog>, the polyfill ' +
        'may not work correctly', element);
  }
  if (element.localName !== 'dialog') {
    throw new Error('Failed to register dialog: The element is not a dialog.');
  }
  new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
};

/**
 * @param {!Element} element to upgrade, if necessary
 */
dialogPolyfill.registerDialog = function(element) {
  if (!element.showModal) {
    dialogPolyfill.forceRegisterDialog(element);
  }
};

/**
 * @constructor
 */
dialogPolyfill.DialogManager = function() {
  /** @type {!Array<!dialogPolyfillInfo>} */
  this.pendingDialogStack = [];

  var checkDOM = this.checkDOM_.bind(this);

  // The overlay is used to simulate how a modal dialog blocks the document.
  // The blocking dialog is positioned on top of the overlay, and the rest of
  // the dialogs on the pending dialog stack are positioned below it. In the
  // actual implementation, the modal dialog stacking is controlled by the
  // top layer, where z-index has no effect.
  this.overlay = document.createElement('div');
  this.overlay.className = '_dialog_overlay';
  this.overlay.addEventListener('click', function(e) {
    this.forwardTab_ = undefined;
    e.stopPropagation();
    checkDOM([]);  // sanity-check DOM
  }.bind(this));

  this.handleKey_ = this.handleKey_.bind(this);
  this.handleFocus_ = this.handleFocus_.bind(this);

  this.zIndexLow_ = 100000;
  this.zIndexHigh_ = 100000 + 150;

  this.forwardTab_ = undefined;

  if ('MutationObserver' in window) {
    this.mo_ = new MutationObserver(function(records) {
      var removed = [];
      records.forEach(function(rec) {
        for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
          if (!(c instanceof Element)) {
            continue;
          } else if (c.localName === 'dialog') {
            removed.push(c);
          }
          removed = removed.concat(c.querySelectorAll('dialog'));
        }
      });
      removed.length && checkDOM(removed);
    });
  }
};

/**
 * Called on the first modal dialog being shown. Adds the overlay and related
 * handlers.
 */
dialogPolyfill.DialogManager.prototype.blockDocument = function() {
  document.documentElement.addEventListener('focus', this.handleFocus_, true);
  document.addEventListener('keydown', this.handleKey_);
  this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
};

/**
 * Called on the first modal dialog being removed, i.e., when no more modal
 * dialogs are visible.
 */
dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
  document.documentElement.removeEventListener('focus', this.handleFocus_, true);
  document.removeEventListener('keydown', this.handleKey_);
  this.mo_ && this.mo_.disconnect();
};

/**
 * Updates the stacking of all known dialogs.
 */
dialogPolyfill.DialogManager.prototype.updateStacking = function() {
  var zIndex = this.zIndexHigh_;

  for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
    dpi.updateZIndex(--zIndex, --zIndex);
    if (i === 0) {
      this.overlay.style.zIndex = --zIndex;
    }
  }

  // Make the overlay a sibling of the dialog itself.
  var last = this.pendingDialogStack[0];
  if (last) {
    var p = last.dialog.parentNode || document.body;
    p.appendChild(this.overlay);
  } else if (this.overlay.parentNode) {
    this.overlay.parentNode.removeChild(this.overlay);
  }
};

/**
 * @param {Element} candidate to check if contained or is the top-most modal dialog
 * @return {boolean} whether candidate is contained in top dialog
 */
dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
  while (candidate = findNearestDialog(candidate)) {
    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
      if (dpi.dialog === candidate) {
        return i === 0;  // only valid if top-most
      }
    }
    candidate = candidate.parentElement;
  }
  return false;
};

dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
  var target = event.composedPath ? event.composedPath()[0] : event.target;

  if (this.containedByTopDialog_(target)) { return; }

  if (document.activeElement === document.documentElement) { return; }

  event.preventDefault();
  event.stopPropagation();
  safeBlur(/** @type {Element} */ (target));

  if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key

  var dpi = this.pendingDialogStack[0];
  var dialog = dpi.dialog;
  var position = dialog.compareDocumentPosition(target);
  if (position & Node.DOCUMENT_POSITION_PRECEDING) {
    if (this.forwardTab_) {
      // forward
      dpi.focus_();
    } else if (target !== document.documentElement) {
      // backwards if we're not already focused on <html>
      document.documentElement.focus();
    }
  }

  return false;
};

dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
  this.forwardTab_ = undefined;
  if (event.keyCode === 27) {
    event.preventDefault();
    event.stopPropagation();
    var cancelEvent = new supportCustomEvent('cancel', {
      bubbles: false,
      cancelable: true
    });
    var dpi = this.pendingDialogStack[0];
    if (dpi && safeDispatchEvent(dpi.dialog, cancelEvent)) {
      dpi.dialog.close();
    }
  } else if (event.keyCode === 9) {
    this.forwardTab_ = !event.shiftKey;
  }
};

/**
 * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
 * removed and immediately readded don't stay modal, they become normal.
 *
 * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
 */
dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
  // This operates on a clone because it may cause it to change. Each change also calls
  // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
  // at a time?!
  var clone = this.pendingDialogStack.slice();
  clone.forEach(function(dpi) {
    if (removed.indexOf(dpi.dialog) !== -1) {
      dpi.downgradeModal();
    } else {
      dpi.maybeHideModal();
    }
  });
};

/**
 * @param {!dialogPolyfillInfo} dpi
 * @return {boolean} whether the dialog was allowed
 */
dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
  var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
  if (this.pendingDialogStack.length >= allowed) {
    return false;
  }
  if (this.pendingDialogStack.unshift(dpi) === 1) {
    this.blockDocument();
  }
  this.updateStacking();
  return true;
};

/**
 * @param {!dialogPolyfillInfo} dpi
 */
dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
  var index = this.pendingDialogStack.indexOf(dpi);
  if (index === -1) { return; }

  this.pendingDialogStack.splice(index, 1);
  if (this.pendingDialogStack.length === 0) {
    this.unblockDocument();
  }
  this.updateStacking();
};

dialogPolyfill.dm = new dialogPolyfill.DialogManager();
dialogPolyfill.formSubmitter = null;
dialogPolyfill.imagemapUseValue = null;

/**
 * Installs global handlers, such as click listers and native method overrides. These are needed
 * even if a no dialog is registered, as they deal with <form method="dialog">.
 */
if (window.HTMLDialogElement === undefined) {

  /**
   * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
   * one that returns the correct value.
   */
  var testForm = document.createElement('form');
  testForm.setAttribute('method', 'dialog');
  if (testForm.method !== 'dialog') {
    var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
    if (methodDescriptor) {
      // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
      // and don't bother to update the element.
      var realGet = methodDescriptor.get;
      methodDescriptor.get = function() {
        if (isFormMethodDialog(this)) {
          return 'dialog';
        }
        return realGet.call(this);
      };
      var realSet = methodDescriptor.set;
      /** @this {HTMLElement} */
      methodDescriptor.set = function(v) {
        if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
          return this.setAttribute('method', v);
        }
        return realSet.call(this, v);
      };
      Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
    }
  }

  /**
   * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
   * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
   * document.activeElement.
   */
  document.addEventListener('click', function(ev) {
    dialogPolyfill.formSubmitter = null;
    dialogPolyfill.imagemapUseValue = null;
    if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission

    var target = /** @type {Element} */ (ev.target);
    if ('composedPath' in ev) {
      var path = ev.composedPath();
      target = path.shift() || target;
    }
    if (!target || !isFormMethodDialog(target.form)) { return; }

    var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
    if (!valid) {
      if (!(target.localName === 'input' && target.type === 'image')) { return; }
      // this is a <input type="image">, which can submit forms
      dialogPolyfill.imagemapUseValue = ev.offsetX + ',' + ev.offsetY;
    }

    var dialog = findNearestDialog(target);
    if (!dialog) { return; }

    dialogPolyfill.formSubmitter = target;

  }, false);

  /**
   * Global 'submit' handler. This handles submits of `method="dialog"` which are invalid, i.e.,
   * outside a dialog. They get prevented.
   */
  document.addEventListener('submit', function(ev) {
    var form = ev.target;
    var dialog = findNearestDialog(form);
    if (dialog) {
      return;  // ignore, handle there
    }

    var submitter = findFormSubmitter(ev);
    var formmethod = submitter && submitter.getAttribute('formmethod') || form.getAttribute('method');
    if (formmethod === 'dialog') {
      ev.preventDefault();
    }
  });

  /**
   * Replace the native HTMLFormElement.submit() method, as it won't fire the
   * submit event and give us a chance to respond.
   */
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  var replacementFormSubmit = function () {
    if (!isFormMethodDialog(this)) {
      return nativeFormSubmit.call(this);
    }
    var dialog = findNearestDialog(this);
    dialog && dialog.close();
  };
  HTMLFormElement.prototype.submit = replacementFormSubmit;
}

// If the locale has been changed, we need to clear the users cart and adjust the site accordingly.
const localeCheck = async () => {
  const modal = document.querySelector('#country-changed');
  const modalCloseButtons = modal.querySelectorAll('button.close-modal');
  if (modal) dialogPolyfill.registerDialog(modal);
  modalCloseButtons.forEach(button => {
    button.addEventListener('click', () => {
      modal.close();
    });
  });
  const ajaxCart = new shopifyCart();
  localStorage.getItem("lastCountry");
  localStorage.getItem("lastLocale");
  const currentLocale = window.Shopify?.locale;
  const currentCountry = window.Shopify?.country;
  const setLocalStorage = () => {
    localStorage.setItem("lastCountry", currentCountry);
    localStorage.setItem("lastLocale", currentLocale);
  };

  // if url contains ?redirected=true, we want to show the modal, clear the cart and remove redirected=true from the url
  if (window.location.href.includes('redirected=true') && window.location.href.includes('items=true')) {
    await ajaxCart.clearCart();
    const cartBubble = document.querySelectorAll('.cart-count-bubble span');
    cartBubble.forEach(element => {
      element.innerHTML = '0';
    });
    setLocalStorage();
    const url = new URL(window.location);
    const searchParams = url.searchParams;
    searchParams.delete('redirected');
    searchParams.delete('items');
    const newUrl = url.href;
    window.history.pushState({}, '', newUrl);

    // If on the cart page, we want to reload the page to show the empty cart
    if (window.location.href.includes('/cart')) {
      window.location.reload();
    } else {
      modal.showModal();
    }
    return true;
  }
  if (window.location.href.includes('cart=true')) {
    const url = new URL(window.location);
    const searchParams = url.searchParams;
    searchParams.delete('cart');
    const newUrl = url.href;
    window.history.pushState({}, '', newUrl);
    modal.showModal();
  }
  setLocalStorage();
};
window.addEventListener("load", localeCheck);

const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add("animated");
      // console.log(entry);
      animationObserver.unobserve(entry.target);
    }
  });
});
const animatedElements = document.querySelectorAll(".scroll-animation");
animatedElements.forEach(el => {
  animationObserver.observe(el);
});

// /**
//  * Fallback for no support for IntersectionObserver API
//  */
// if (
//   !("IntersectionObserver" in window) ||
//   !("IntersectionObserverEntry" in window) ||
//   !("intersectionRatio" in window.IntersectionObserverEntry.prototype) ||
//   !("isIntersecting" in window.IntersectionObserverEntry.prototype)
// ) {
//   animatedElements.forEach((el) => {
//     el.classList.add("animated");
//   });
// }

const stickySection = document.querySelector('.article-content-side__right');
const stickyHeader = document.getElementById('shopify-section-header');
document.querySelector('.article-content-side__left');
document.addEventListener('DOMContentLoaded', () => {
  const relatedArticlesGrid = document.querySelector('.related-articles .grid.product-grid');
  if (relatedArticlesGrid && relatedArticlesGrid.childElementCount == 0) {
    document.querySelector('.related-articles').style.display = 'none';
    if (document.querySelector('.shop-products-grid')) {
      document.querySelector('.shop-products-grid').classList.add('no-related');
    }
  }
});
let isObserving = false;
const observer = new MutationObserver(m => {
  m.forEach(mut => {
    if (mut.attributeName == "class") {
      if (!stickyHeader.classList.contains('shopify-section-header-hidden')) {
        const headerHeight = stickyHeader.offsetHeight;
        if (stickySection && stickySection.style) {
          stickySection.style.top = `${headerHeight + 40}px`;
        }
      } else {
        if (stickySection && stickySection.style) {
          stickySection.style.top = "";
        }
      }
    }
  });
});
if (window.innerWidth >= 750) {
  isObserving = true;
  observer.observe(stickyHeader, {
    attributes: true
  });
}
const initializeSwiper = () => {
  const swiperInstance = document?.querySelector('.swiper.shop-products-section')?.swiper;
  if (window.innerWidth <= 750) {
    if (!swiperInstance) {
      new Swiper('.swiper.shop-products-section', {
        spaceBetween: 15,
        slidesPerView: 1.24
      });
    }
  } else {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }
  }
};
initializeSwiper();
window.addEventListener('resize', () => {
  if (!isObserving && window.innerWidth >= 750) {
    observer.observe(stickyHeader, {
      attributes: true
    });
    isObserving = true;
  } else if (isObserving && window.innerWidth < 750) {
    observer.disconnect();
    isObserving = false;
  }
  initializeSwiper();
});

document.querySelectorAll(".ctr__button").forEach(button => {
  const variantId = button.getAttribute("data-id");
  button.addEventListener("click", e => {
    addRoutineItems([{
      quantity: 1,
      id: variantId
    }]);
  });
});
document.querySelectorAll(".ctr__add_mulitple_button").forEach(button => {
  let itemsArray = [];
  let variantIds = button.getAttribute("data-id").split(',');
  console.log(variantIds);
  variantIds.forEach(id => {
    itemsArray.push({
      quantity: 1,
      id: id
    });
  });
  button.addEventListener("click", e => {
    addRoutineItems(itemsArray);
  });
});
const addToCart = data => {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch("/cart/add.js", {
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest"
    },
    method: "POST"
  }).then(response => response.json()).then(response => {
    cart.renderContents(response);
  }).catch(err => {
    console.error(err);
  });
};
const addRoutineItems = variantIdArray => {
  var data = {
    items: variantIdArray,
    sections: 'cart-notification-product,cart-icon-bubble',
    sections_url: window.location.pathname
  };
  addToCart(data);
};
new Swiper('.complete_the_routine__swiper', {
  slidesPerView: 1.1,
  spaceBetween: 15,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">Step ' + (index + 1) + "</span>";
    }
  },
  breakpoints: {
    990: {
      slidesPerView: 4,
      spaceBetween: 1
    }
  }
});

const closeDrawer = e => {
  document.body.classList.remove("drawer-open");
  const drawer = e.target.closest(".drawer_menu");
  drawer.classList.remove("open");
};
const openDrawer = target => {
  document.body.classList.add("drawer-open");
  const drawer = document.getElementById(target);
  drawer.classList.add("open");
  drawer.focus();
};
const openDrawerButton = document.querySelectorAll(".open-drawer");
openDrawerButton.forEach(button => {
  button.addEventListener("click", e => {
    let target = e.target.getAttribute("data-target");
    openDrawer(target);
  });
});
const drawer_menu = document.querySelectorAll(".drawer_menu");
drawer_menu.forEach(drawer => {
  const closeButton = drawer.querySelectorAll(".close-drawer");
  closeButton.forEach(button => {
    button.addEventListener("click", e => {
      closeDrawer(e);
    });
  });
  drawer.addEventListener("click", e => {
    if (e.target.classList.contains("drawer_menu")) {
      closeDrawer(e);
    }
  });
});

class customSelect extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[type="hidden"]'),
      button: this.querySelector("button"),
      button_text: this.querySelector(".disclosure__button_text"),
      panel: this.querySelector("ul")
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach(item => item.addEventListener("click", this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    event.stopPropagation();
    // const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    console.log("custom select value", this.elements.input.value);
    this.elements.button_text.innerHTML = event.currentTarget.text;
    // if (form) form.submit();
    this.hidePanel();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("custom-select", customSelect);

document.addEventListener('DOMContentLoaded', () => {
  const facets = document.querySelector('.facets.facets-pill');
  const showHideFacets = () => {
    const activeFacetsDesktop = document.querySelector('.active-facets.active-facets-desktop');
    const activeFacetsMobile = document.querySelector('.active-facets.active-facets-mobile');
    if (window.innerWidth >= 750) {
      if (activeFacetsDesktop?.childElementCount > 1) {
        facets?.classList?.remove('hidden');
      } else {
        facets?.classList?.add('hidden');
      }
    } else {
      if (activeFacetsMobile?.childElementCount > 1) {
        activeFacetsMobile?.classList?.remove('hidden');
      } else {
        activeFacetsMobile?.classList?.add('hidden');
      }
    }
  };
  showHideFacets();
  const observer = new MutationObserver(m => {
    m.forEach(mut => {
      showHideFacets();
    });
  });
  facets && observer.observe(facets, {
    subtree: true,
    childList: true
  });
});

const featuredBlogSwiper = () => {
  const swipers = document.querySelectorAll(".swiper.featured_blog__swiper");
  swipers.forEach(swiper_instance => {
    const slide_count_desktop = parseFloat(swiper_instance.getAttribute("data-slide-count-desktop"));
    const slide_count_mobile = parseFloat(swiper_instance.getAttribute("data-slide-count-mobile"));
    new Swiper(swiper_instance, {
      // centerInsufficientSlides:true,
      slidesPerView: slide_count_mobile,
      spaceBetween: 20,
      // loop:true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        990: {
          slidesPerView: slide_count_desktop,
          spaceBetween: 30
        }
      }
    });
  });
};
featuredBlogSwiper();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    featuredBlogSwiper();
  });
}

const featuredCollections = () => {
  const featuredCollectionSwipers = document.querySelectorAll(".featured_collection__swiper");
  featuredCollectionSwipers.forEach(swiper_instance => {
    const column_count_desktop = parseFloat(swiper_instance.getAttribute("data-slide-count-desktop"));
    const column_count_mobile = parseFloat(swiper_instance.getAttribute("data-slide-count-mobile"));
    new Swiper(swiper_instance, {
      slidesPerView: column_count_mobile,
      spaceBetween: 20,
      // loop:true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        990: {
          slidesPerView: column_count_desktop,
          spaceBetween: 30
        }
      }
    });
  });
};
featuredCollections();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    featuredCollections();
  });
}

const featuredReviews = () => {
  const featuredReviewsSwiper = document.querySelectorAll(".featured_reviews__swiper");
  featuredReviewsSwiper.forEach(swiper_instance => {
    const slide_count_desktop = parseFloat(swiper_instance.getAttribute("data-slide-count-desktop"));
    const slide_count_mobile = parseFloat(swiper_instance.getAttribute("data-slide-count-mobile"));
    let loop = swiper_instance.getAttribute("data-loop");
    const auto_delay = parseFloat(swiper_instance.getAttribute("data-auto-delay"));
    const auto_slide = swiper_instance.getAttribute("data-auto-slide");
    let autoplay = false;
    if (auto_slide == "true") {
      autoplay = {
        delay: auto_delay
      };
    }
    if (loop == "true") {
      loop = true;
    } else {
      loop = false;
    }
    new Swiper(swiper_instance, {
      // centerInsufficientSlides:true,
      slidesPerView: slide_count_mobile,
      autoplay: autoplay,
      spaceBetween: 20,
      loop: loop,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        990: {
          slidesPerView: slide_count_desktop,
          spaceBetween: 30
        }
      }
    });
  });
};
featuredReviews();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    featuredReviews();
  });
}

const transparentHeaderSection = document.querySelector(".header--transparent--true");
const headerWrapper = document.querySelector(".header-wrapper");
let transparentHeaderSectionColor = transparentHeaderSection?.getAttribute("data-transparent-color");
const headerSection = document.getElementById("shopify-section-header");
let transparentHeaderSectionIntersecting = false;
let transparentHeaderSectionAllowed = true;
const getScrollPositionTop = () => {
  let scrollAtTop = false;
  if (document.documentElement.scrollTop == 0) {
    scrollAtTop = true;
  }
  return scrollAtTop;
};
const setHeaderTransparency = (isIntersecting, isAtTop) => {
  if (isIntersecting && isAtTop) {
    headerSection.classList.add("transparent-header");
    headerWrapper.classList.add(transparentHeaderSectionColor);
    transparentHeaderSectionAllowed = true;
  } else {
    transparentHeaderSectionAllowed = false;
    headerSection.classList.remove("transparent-header");
    headerWrapper.classList.remove(transparentHeaderSectionColor);
  }
};

// This has been essentially made useless ... //
const transparentHeaderObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      transparentHeaderSectionIntersecting = true;
    } else {
      transparentHeaderSectionIntersecting = false;
    }
  });
});
transparentHeaderSection && transparentHeaderObserver.observe(transparentHeaderSection, {
  rootMargin: "0px",
  threshold: 1.0
});
headerSection.addEventListener("mouseenter", e => {
  if (transparentHeaderSectionAllowed) {
    headerSection.classList.remove("transparent-header");
  }
});
headerSection.addEventListener("mouseleave", e => {
  if (transparentHeaderSectionAllowed) {
    if (!document.querySelectorAll(".mega-menu[open]").length) {
      // console.log("this test passed");
      headerSection.classList.add("transparent-header");
    }
  }
});
document.addEventListener('scroll', () => {
  setHeaderTransparency(transparentHeaderSectionIntersecting, getScrollPositionTop());
});
window.addEventListener('load', () => {
  setHeaderTransparency(transparentHeaderSectionIntersecting, getScrollPositionTop());
});
window.addEventListener("click", function (e) {
  if (!headerSection.contains(e.target)) {
    if (transparentHeaderSectionAllowed) {
      headerSection.classList.add("transparent-header");
    }
  }
});
document.querySelector(".header__icon--menu").addEventListener("click", e => {
  if (transparentHeaderSectionAllowed) {
    if (!document.body.classList.contains("drawer-menu-open")) {
      headerSection.classList.add("transparent-header");
    }
  }
});

//Set dynamic VH for touch devices
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);
document.documentElement.style.setProperty("--vh-dynamic", `${vh}px`);
window.addEventListener("resize", () => {
  document.documentElement.style.setProperty("--vh-dynamic", `${vh}px`);
});

const multistoreDialog$1 = document.getElementById('multistore-popup');
if (multistoreDialog$1) dialogPolyfill.registerDialog(multistoreDialog$1);
function multistorePopup(data) {
  if (!multistoreDialog$1) return;
  const country = data.detected_values.country.name;
  const localisationDialog = document.getElementById('localisation-popup');
  const userLocation = multistoreDialog$1.querySelectorAll('.user-location');
  userLocation.forEach(location => {
    location.innerHTML = country;
  });

  // console.log({country});

  const splitURL = window.location.host.split('.');
  const usCountries = ['United States', 'Canada', 'Mexico', 'Puerto Rico', 'Guam', 'American Samoa', 'United States Minor Outlying Islands', 'Virgin Islands, U.S.', 'Northern Mariana Islands'];
  let currentStore = splitURL[splitURL.length - 1];
  if (currentStore == 'us') {
    if (!usCountries.includes(country)) {
      multistoreDialog$1.showModal();
      document.body.classList.add('overflow-hidden');
    }
  } else if (currentStore == 'uk') {
    if (usCountries.includes(country)) {
      multistoreDialog$1.showModal();
      localisationDialog?.close();
      document.body.classList.add('overflow-hidden');
    }
  }

  //For testing stores use ?store="uk"
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const queryStringStore = urlParams.get('store');

  //UK
  if (queryStringStore == 'us') {
    if (!usCountries.includes(country)) {
      multistoreDialog$1.showModal();
      document.body.classList.add('overflow-hidden');
    }
  } else if (queryStringStore == 'uk') {
    if (usCountries.includes(country)) {
      multistoreDialog$1.showModal();
      localisationDialog?.close();
      document.body.classList.add('overflow-hidden');
    }
  }
  const close = multistoreDialog$1.querySelectorAll('.close');
  function closeMultistorePopup() {
    multistoreDialog$1.close();
    setStorePreference(country);
    document.body.classList.remove('overflow-hidden');

    //show localisation modal
    if (!localStorage.getItem('localisationPreferneces')) {
      localisationDialog?.showModal();
    }
  }
  close.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      closeMultistorePopup();
    });
  });
  multistoreDialog$1.addEventListener('cancel', () => {
    closeMultistorePopup();
  });
}
function setStorePreference(country) {
  localStorage.setItem('storePreference', JSON.stringify({
    country: country,
    store: window.location.host
  }));
}
if (!localStorage.getItem('storePreference')) {
  getBrowsingContext().then(data => multistorePopup(data));
}

const openDialog = document.querySelectorAll(".country_language_selector");
const dialog = document.getElementById("localisation-popup");
if (dialog) dialogPolyfill.registerDialog(dialog);
const multistoreDialog = document.getElementById("multistore-popup");
if (multistoreDialog) dialogPolyfill.registerDialog(multistoreDialog);

/**
 * Trigger the localisation popup.
 */
openDialog?.forEach(button => {
  button.addEventListener("click", () => dialog.showModal());
});

/**
 * Set detected language in nav pickers
 */
document.addEventListener("DOMContentLoaded", () => {
  const lang = document.documentElement.getAttribute("lang");
  let languageName = "English";
  switch (lang) {
    case "fr":
      languageName = "Français";
      break;
    case "en":
      languageName = "English";
      break;
    case "de":
      languageName = "Deutsch";
      break;
    case "nl":
      languageName = "Nederlands";
      break;
    default:
      languageName = "English";
  }
  const languageButtons = document.querySelectorAll(".country_language_selector__language");
  languageButtons && languageButtons.forEach(language => {
    language.innerHTML = languageName;
  });
});
function setBrowsingContext(data) {
  if (!dialog) return;
  const detectedCountry = data.detected_values?.country?.handle;
  const detectedLanguage = data.suggestions[0]?.parts?.language?.handle;

  // const language = data.suggestions[0].parts.language.handle;
  const submitButton = document.getElementById("submit-localisation");
  const languageInput = dialog.querySelector('input[name="language_code"]');
  const countryInput = dialog.querySelector('input[name="country_code"]');
  const requestPath = dialog.querySelector('input[name="request_path"]');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const queryStringCountry = urlParams.get("country");
  const queryStringLanguage = urlParams.get("language");

  /**
   * Check the user's localisationPreferences in localstorage, if null, display localisation popup.
   */
  const localisationPreferences = JSON.parse(localStorage.getItem("localisationPreferences"));

  /**
   * country to 1. preference in localstorage 2. querystring detected 3. browsing context detected 4. current localisation (set in input via liquid)
   */
  const availableCountry = localisationPreferences ? localisationPreferences.country : queryStringCountry || detectedCountry || countryInput.value;
  const availableLanguage = localisationPreferences ? localisationPreferences.language : queryStringLanguage || detectedLanguage || languageInput.value;

  // console.log({ availableLanguage });

  /**
   * setLocalisationDefaults()
   * If user does not have localisationPreferences set in local storage, this function
   * will preselect the appropriate form options based on their detected browsing context.
   */
  function setLocalisationDefaults(country = availableCountry, language = availableLanguage) {
    const countryList = document.getElementById("CountryPickerList");
    const languageList = document.getElementById("LanguagePickerList");
    const languageListItem = languageList.querySelector(`[lang="${language}"]`);
    const countryListItem = countryList.querySelector(`[country="${country}"]`);
    const languageListButton = languageList.closest(".disclosure")?.querySelector(".disclosure__button_text");
    const countryListButton = countryList.closest(".disclosure")?.querySelector(".disclosure__button_text");
    const country_tag = dialog.querySelectorAll(".country_tag")[0];

    /**
     * Check if user's preferred language is available in the store's available languages.
     */
    if (languageListItem) {
      languageInput.value = language;
      languageListButton.innerHTML = languageList.querySelector(`[lang="${language}"]`).text;
    }

    /**
     *  Check if user's country is available in the store's available markets.
     */
    if (countryListItem && country !== "US") {
      const flag = dialog.querySelectorAll(".localisation__country_flag img")[0];
      countryInput.value = country;
      countryListButton.innerHTML = countryListItem.children[0].text;
      country_tag.innerHTML = countryListItem.getAttribute("country_name");
      flag.setAttribute("src", `http://cdn.shopify.com/static/images/flags/${availableCountry.toLowerCase()}.svg?width=80`);
      flag.setAttribute("srcset", `http://cdn.shopify.com/static/images/flags/${availableCountry.toLowerCase()}.svg?width=80`);
    }
  }

  /**
   * setLocalisationPreferences()
   * Store the user's preferred localisation in localstorage.
   */
  function setLocalisationPreferences(country, language) {
    localStorage.setItem("localisationPreferences", JSON.stringify({
      country: country,
      language: language
    }));
    setLocalisationDefaults(country, language);
  }
  if (!localisationPreferences) {
    if (queryStringCountry && queryStringLanguage) {
      //TODO: Add language querystring and/or parse domain.
      //TODO: cleanup
      setLocalisationPreferences(queryStringCountry, queryStringLanguage);
    }

    // if (
    //   detectedCountry === countryInput.value &&
    //   detectedLanguage === languageInput.value
    // ) {
    //   setLocalisationPreferences(detectedCountry, detectedLanguage);
    // } else {
    //   setLocalisationDefaults();
    // }
    setLocalisationDefaults();
    if (multistoreDialog) {
      if (!multistoreDialog.hasAttribute("open")) {
        dialog.showModal();
        document.body.classList.add("overflow-hidden");
      } else {
        dialog.close();
      }
    } else {
      dialog.showModal();
      document.body.classList.add("overflow-hidden");
    }
  }
  //  else {
  //   setLocalisationDefaults(
  //     localisationPreferences.country,
  //     localisationPreferences.language
  //   );
  // }
  /**
   * Submit set localisationPreferences submit the localisation form.
   */

  function submitLocalisationForm() {
    console.log("submit");

    // if (localisationPreferences) {
    //   if (
    //     localisationPreferences.country == countryInput.value &&
    //     localisationPreferences.language == languageInput.value
    //   ) {
    //     dialog.close();
    //     return;
    //   }
    // }

    console.log("languageInput.value", languageInput.value);
    setLocalisationPreferences(countryInput.value, languageInput.value);
    // if (form) form.submit();

    if (countryInput.value == "US") {
      {
        window.location = `https://boucleme.us`;
        return;
      }
    }
    let searchParams = new URL(window.location).searchParams;
    searchParams.set("country", countryInput.value);
    searchParams.set("language", languageInput.value);
    searchParams.set("redirected", true);

    // if items are in the cart, set items=true in the url
    const cartItems = document.querySelector(".cart-count-bubble span");
    if (cartItems.innerHTML > 0) {
      searchParams.set("items", true);
    }
    if (window.location.href.includes('/cart')) {
      searchParams.set("cart", true);
    }
    if (languageInput.value == "en") {
      console.log(`https://www.boucleme.co.uk${requestPath.value}?${searchParams.toString()}`);
      window.location = `https://www.boucleme.co.uk${requestPath.value}?${searchParams.toString()}`;
    } else {
      console.log(`https://${languageInput.value}.boucleme.co.uk${requestPath.value}?${searchParams.toString()}`);
      window.location = `https://${languageInput.value}.boucleme.co.uk${requestPath.value}?${searchParams.toString()}`;
    }
  }

  /**
   * Localisation Popup functionality
   */
  function localisationPopup() {
    const close = dialog.querySelector(".close");
    close.addEventListener("click", () => {
      dialog.close();
      document.body.classList.remove("overflow-hidden");
      submitLocalisationForm();
    });
    dialog.addEventListener("cancel", () => {
      dialog.close();
      document.body.classList.remove("overflow-hidden");
      submitLocalisationForm();
    });
    submitButton.addEventListener("click", e => {
      e.preventDefault();
      document.body.classList.remove("overflow-hidden");
      submitLocalisationForm();
    });
  }
  localisationPopup();
}
getBrowsingContext().then(data => setBrowsingContext(data));

const multicolumnTabs = document.querySelectorAll(".multicolumn-with-tabs");
multicolumnTabs.forEach(tab_section => {
  tab_section.querySelectorAll(".tab__button").forEach(tab_button => {
    tab_button.addEventListener('click', e => {
      const tab_id = tab_button.getAttribute("data-id");
      tab_section.querySelectorAll(".tab__button").forEach(tab_button => {
        tab_button.classList.remove("active");
        e.target.classList.add("active");
      });
      tab_section.querySelectorAll(".tab__content").forEach(tab_content => {
        if (tab_content.getAttribute('data-id') == tab_id) {
          tab_content.classList.add("active");
        } else {
          tab_content.classList.remove("active");
        }
      });
    });
  });
});
const multicolumnTabsSwipers = () => {
  const multicolumnTabsSwiper = document.querySelectorAll(".swiper.multicolumn-swiper");
  multicolumnTabsSwiper.forEach(swiper_instance => {
    const slide_count_desktop = parseFloat(swiper_instance.getAttribute("data-slide-count-desktop"));
    const slide_count_mobile = parseFloat(swiper_instance.getAttribute("data-slide-count-mobile"));
    new Swiper(swiper_instance, {
      // centerInsufficientSlides:true,
      slidesPerView: slide_count_mobile,
      spaceBetween: 0,
      // loop:true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        990: {
          slidesPerView: slide_count_desktop
          // spaceBetween: 30
        }
      }
    });
  });
};

multicolumnTabsSwipers();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    multicolumnTabsSwipers();
  });
}

const featuredIngredientsSwiper = () => {
  const swipers = document.querySelectorAll(".swiper.featured_ingredients__swiper");
  swipers.forEach(swiper_instance => {
    const column_count_desktop = parseFloat(swiper_instance.getAttribute("data-slide-count-desktop"));
    const column_count_mobile = parseFloat(swiper_instance.getAttribute("data-slide-count-mobile"));
    new Swiper(swiper_instance, {
      slidesPerView: column_count_mobile,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      breakpoints: {
        990: {
          slidesPerView: column_count_desktop,
          spaceBetween: 30
        }
      }
    });
  });
};
featuredIngredientsSwiper();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    featuredIngredientsSwiper();
  });
}

const responsiveIframes = document.querySelectorAll(".rte iframe");
responsiveIframes?.forEach(iframe => {
  const width = parseInt(iframe.getAttribute("width"));
  const height = parseInt(iframe.getAttribute("height"));
  const wrapper = document.createElement('div');
  wrapper.classList.add("responsive-video");
  iframe.parentNode.insertBefore(wrapper, iframe);
  wrapper.appendChild(iframe);
  if (width && height) {
    wrapper.style.paddingTop = height / width * 100 + "%";
  }
});

const textTickerSwiper = () => {
  const swipers = document.querySelectorAll(".swiper.text-ticker__swiper");
  swipers.forEach(swiper_instance => {
    const ticker_speed = parseInt(swiper_instance.getAttribute("data-ticker-speed"));
    new Swiper(swiper_instance, {
      spaceBetween: 0,
      centeredSlides: true,
      speed: ticker_speed,
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: false,
      freeMode: true,
      disableOnInteraction: true,
      grabCursor: false,
      autoplay: {
        delay: 1
      }
    });
  });
};
textTickerSwiper();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    textTickerSwiper();
  });
}

const uspSwipers = () => {
  const swipers = document.querySelectorAll(".usp-swiper--true");
  swipers.forEach(swiper_instance => {
    parseFloat(swiper_instance.getAttribute("data-column-count-desktop"));
    parseFloat(swiper_instance.getAttribute("data-column-count-mobile"));
    const slide_count = parseFloat(swiper_instance.getAttribute("data-slide-count"));
    const auto_delay = parseFloat(swiper_instance.getAttribute("data-auto-delay"));
    const auto_slide = swiper_instance.getAttribute("data-auto-slide");
    let autoplay = false;
    if (auto_slide == "true") {
      autoplay = {
        delay: auto_delay
      };
    }
    new Swiper(swiper_instance, {
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: autoplay,
      centerInsufficientSlides: true,
      breakpoints: {
        990: {
          slidesPerView: slide_count,
          spaceBetween: 15,
          effect: ''
        }
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      }
      // pagination: {
      //   el: '.swiper-pagination',
      //   type: 'bullets'
      // }
    });

    // const show_pagination = () => {
    //   if (window.innerWidth <= 749) {
    //     swiper_instance.querySelector(".swiper-pagination").classList.remove("hidden");
    //   }
    //   if (window.innerWidth >= 750) {
    //     swiper_instance.querySelector(".swiper-pagination").classList.add("hidden");
    //   }
    // }
    // show_pagination();

    // window.onresize = () => {
    //   show_pagination();
    // }
  });
};

uspSwipers();
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    uspSwipers();
  });
}
